import { fromJS, Map } from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import * as log from 'loglevel';
import {
    GenericRequestMessage,
    GenericResponseMessage,
    GenericRequestMessageType,
} from '../genericMessage';

const convertFromJovoOutput = (output: any) => {
    const convertTextOutput = () => ({
        text: output.message,
    });

    const convertButtonOutput = ({ text, value, payload }: any) => {
        if (payload && payload.intent) {
            return {
                type: 'postback',
                title: text,
                payload,
            };
        } else if (payload && payload.url) {
            return {
                type: 'web_url',
                title: text,
                url: payload.url,
            };
        } else if (payload && payload.internalUrlName) {
            return {
                type: 'web_url_internal',
                title: text,
                payload: {
                    urlName: payload.internalUrlName,
                    urlParams: payload.internalUrlParams || {},
                },
            };
        } else {
            return {
                type: 'postback',
                title: text,
                payload: value || text,
            };
        }
    };

    const convertQuickRepliesOutput = () => ({
        text: output.message,
        buttons: (output.quickreplies && output.quickreplies.map(convertButtonOutput)) || [],
    });

    const convertImageOutput = () => ({
        attachment: {
            type: 'image',
            payload: {
                title: output.title,
                src: output.url,
            },
        },
    });

    const convertVideoOutput = () => ({
        attachment: {
            type: 'video',
            payload: {
                title: output.title,
                src: output.url,
            },
        },
    });

    const convertCarouselPanel = ({ title, subtitle, imageUrl, action, buttons }: any) => ({
        title,
        subtitle,
        image_url: imageUrl,
        default_action: {
            type: 'web_url',
            url: action.url,
        },
        buttons: (buttons && buttons.map(convertButtonOutput)) || [],
    });

    const convertCarouselOutput = () => ({
        attachment: {
            type: 'template',
            payload: {
                template_type: 'generic',
                elements: (output.panels && output.panels.map(convertCarouselPanel)) || [],
            },
        },
    });

    const converters = Map<string, Function>({
        text: convertTextOutput,
        quickreplies: convertQuickRepliesOutput,
        image: convertImageOutput,
        video: convertVideoOutput,
        carousel: convertCarouselOutput,
    });

    return converters.get(output.type, () => {
        log.debug('unknown output type', output.type);
        return convertTextOutput;
    })();
};

export const parseRequest = (data: any): GenericRequestMessage => {
    // TBD
    return {
        type: GenericRequestMessageType.TEXT,
        body: 'tbd',
    };
};

export const parseResponse = (data: any): GenericResponseMessage => {
    return {
        output: data?.output?.map(convertFromJovoOutput),
        state: data?.session?.data,
    };
};

export const buildRequest = (message: GenericRequestMessage): any => {
    const data = fromJS({
        version: '1.0.0',
        type: 'platform-cui-web',
        request: {
            id: uuidv4(),
            timestamp: new Date().toISOString(),
            type: message.type,
        },
        locale: message.locale || 'de',
        context: {
            session: {
                // id: data.session_id,
                data: message.state || {},
            },
        },
    });

    const requestData =
        message.type === GenericRequestMessageType.TEXT
            ? fromJS({ request: { body: { text: message.body } } })
            : fromJS({ request: { nlu: message.body } });

    return data.mergeDeep(requestData as any).toJS();
};

export const buildResponse = (message: GenericResponseMessage): any => {
    // TBD
};
